import { useTranslation } from "@manapp/ui"
import type { ReactNode } from "react"

import { useAuthController, useAuthState } from "../auth/auth-context"
import { CenteredScreen, Message, PrimaryAction } from "./screens"

/** Renders children only when signed in; otherwise the sign-in, failure or loading screens. */
export function AuthGate({ children }: { children: ReactNode }) {
  const state = useAuthState()
  const controller = useAuthController()
  const { t } = useTranslation()

  switch (state.status) {
    case "loading":
      return <CenteredScreen title={t("app.loading")} />
    case "signed-in":
      return <>{children}</>
    case "error":
      return (
        <CenteredScreen title={t("auth.signInTitle")}>
          <Message>{state.failure === "cancelled" ? t("auth.cancelled") : t("auth.failed")}</Message>
          <PrimaryAction onClick={() => void controller.signIn()}>{t("auth.retry")}</PrimaryAction>
        </CenteredScreen>
      )
    case "signed-out":
      return (
        <CenteredScreen title={t("auth.signInTitle")}>
          {state.reason === "expired" ? <Message>{t("auth.expired")}</Message> : null}
          {state.reason === "signed-out" ? <Message>{t("auth.signedOut")}</Message> : null}
          <PrimaryAction onClick={() => void controller.signIn()}>{t("auth.signIn")}</PrimaryAction>
        </CenteredScreen>
      )
  }
}
